import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField
} from '@material-ui/core';
import { useState } from 'react';
import { useSnackbar } from '../../../../../hooks/useSnackbar';
import { renameUserSavedView } from '../../../../../services/savedView';
import { ButtonWithPromise } from '../../../../../components/ButtonWithPromise';
import { DialogTitleWithTypography } from '../../../../../components/DialogTitleWithTypography';

type Props = {
  open: boolean;
  onClose: () => void;
  viewId: string;
  currentName: string;
};

export const RenameViewModal = ({
  open,
  onClose,
  viewId,
  currentName
}: Props) => {
  const [name, setName] = useState(currentName);
  const [error, setError] = useState<string | null>(null);
  const { enqueueSnackbarSuccess } = useSnackbar();

  const handleClose = () => {
    setName(currentName);
    setError(null);
    onClose();
  };

  const handleSave = async () => {
    const trimmed = name.trim();
    if (!trimmed) return;
    setError(null);
    try {
      await renameUserSavedView({ viewId, name: trimmed });
      enqueueSnackbarSuccess('Saved view renamed.');
      handleClose();
    } catch (err: any) {
      setError(err?.message || 'Failed to rename view. Please try again.');
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitleWithTypography>Rename saved view</DialogTitleWithTypography>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label="View name"
          value={name}
          error={Boolean(error)}
          helperText={error ?? undefined}
          onChange={(e) => {
            setName(e.target.value);
            if (error) setError(null);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && name.trim()) {
              e.preventDefault();
              handleSave();
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <ButtonWithPromise
          variant="contained"
          color="primary"
          disabled={!name.trim() || name.trim() === currentName}
          onClick={handleSave}
          pending="Saving..."
        >
          Save
        </ButtonWithPromise>
      </DialogActions>
    </Dialog>
  );
};
